import { render, staticRenderFns } from "./TAVAcademyInPress.vue?vue&type=template&id=406e2210&scoped=true&"
import script from "./TAVAcademyInPress.vue?vue&type=script&lang=js&"
export * from "./TAVAcademyInPress.vue?vue&type=script&lang=js&"
import style0 from "./TAVAcademyInPress.vue?vue&type=style&index=0&id=406e2210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406e2210",
  null
  
)

export default component.exports